import React, { useState } from "react";
import _ from "lodash";

import ConfirmationModal from "./ConfirmationModal";
import Portal from "./Portal";
import Select from "react-select";
import Draggable from "react-draggable";
import ReactTooltip from "react-tooltip";

export const MultiSelectionModal = ({
    currentSelection,
    options,
    onSelection,
    heading,
    onCancel,
    viewOnly = false,
    containerClassname = "",
    isSurveyProjectView = false,
    isSurveyProjectForm = false,
    preSelectedValues = [],
    className = "",
    isLoading = false,
    isDropdownloading = false,
    isDraggable = false,
    isAssetSurveyProject = false,
    isAutoPopulate = false,
    ...props
}) => {
    const [selectedValues, setSelectedValues] = useState(currentSelection || []);
    const [showConfirmModal, setShowConfirmModal] = useState(false);

    const onSelectValues = selectedOptions => {
        const transformedValues = selectedOptions ? selectedOptions?.map(option => option.value) : [];
        setSelectedValues(transformedValues);
    };
    const selectedOptions = selectedValues?.map(item => ({
        value: item,
        label: item.name
    }));

    const removeSelectedValue = valueToRemove => {
        setSelectedValues(selectedValues?.filter(item => item?.id !== valueToRemove?.id));
    };

    const renderConfirmationModal = () => {
        if (!showConfirmModal) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        type="cancel"
                        heading={"Do you want to clear and lose all changes?"}
                        message={"This action cannot be reverted, are you sure that you need to cancel?"}
                        onNo={() => setShowConfirmModal(false)}
                        onYes={clearForm}
                    />
                }
                onCancel={() => setShowConfirmModal(false)}
            />
        );
    };

    const handleSubmit = async () => {
        onSelection(selectedValues, () => isSurveyProjectForm && onCancel());
        if (!isSurveyProjectForm) onCancel();
    };

    const cancelForm = () => {
        if (_.isEqual(selectedValues, currentSelection)) {
            clearForm();
        } else {
            setShowConfirmModal(true);
        }
    };

    const clearForm = async () => {
        setSelectedValues([]);
        onCancel();
    };

    const sortAlphabetically = array => {
        return _.sortBy(
            array?.filter(item => item?.name),
            [item => item?.name?.toLowerCase()]
        );
    };

    const sortedOptions = sortAlphabetically(options?.filter(option => !selectedValues?.some(selected => selected.id === option.id)))?.map(
        option => ({
            value: option,
            label: option?.name,
            disabled: option?.disabled ?? false,
            disabledTooltip: option?.disabledTooltip ?? ""
        })
    );
    const sortedCurrentSelection = sortAlphabetically(Array.isArray(currentSelection) ? currentSelection : []);
    const sortedSelectedValues = sortAlphabetically(selectedValues);
    return (
        <React.Fragment>
            <div
                className={`modal modal-region add-new-template ${isSurveyProjectView ? "survey-view-modal" : ""} ${className ?? ""}`}
                style={{ display: "block" }}
                id="modalId"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <Draggable handle=".draggable" cancel=".not-draggable" disabled={!isDraggable}>
                    <div className="modal-dialog build-multi-modal" role="document">
                        <div className="modal-content">
                            <div className={`modal-header ${isDraggable ? "draggable" : ""}`}>
                                <h5 className="modal-title" id="exampleModalLabel">
                                    {heading}
                                </h5>
                                <button
                                    type="button"
                                    className="close .not-draggable"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => cancelForm()}
                                >
                                    <span aria-hidden="true">
                                        <img src="/img/close.svg" alt="" />
                                    </span>
                                </button>
                            </div>

                            <div className={`modal-body region-otr build-type-mod ${containerClassname} ${isDraggable ? "draggable" : ""}`}>
                                {!viewOnly ? (
                                    <>
                                        <div>
                                            {isSurveyProjectForm &&
                                                preSelectedValues?.map(e => <span className="global-survey-fixed-span">{e?.name}</span>)}
                                        </div>
                                        {/* Display selected values */}

                                        <div className="selected-items not-draggable">
                                            {sortedSelectedValues?.map((item, index) => (
                                                <div key={index} className="selected-item badge-select-otr">
                                                    {item?.name}
                                                    <button type="button" className="remove-btn" onClick={() => removeSelectedValue(item)}>
                                                        ✕
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                        <form autoComplete={"nope"}>
                                            <div className="form-group not-draggable">
                                                <div className="formInp bgInp">
                                                    <Select
                                                        isClearable={false}
                                                        isMulti
                                                        options={sortedOptions}
                                                        value={selectedOptions}
                                                        onChange={onSelectValues}
                                                        filterOption={(option, inputValue) =>
                                                            option?.label?.toLowerCase()?.includes(inputValue?.toLowerCase())
                                                        }
                                                        placeholder={`Select ${heading}`}
                                                        classNamePrefix="react-select"
                                                        onKeyDown={e => {
                                                            const input = e.target.value;
                                                            if (!input && e.key === "Backspace") {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        styles={{
                                                            multiValue: () => ({
                                                                display: "none"
                                                            })
                                                        }}
                                                        isLoading={isDropdownloading}
                                                        {...(isAutoPopulate
                                                            ? {
                                                                  isOptionDisabled: option => option?.value?.disabled,
                                                                  formatOptionLabel: option => {
                                                                      if (option?.value?.disabled) {
                                                                          const tooltipId = `tooltip-${option.value.id}`;
                                                                          return (
                                                                              <div data-tip data-for={tooltipId} style={{ cursor: "not-allowed" }}>
                                                                                  {option.label}
                                                                                  <ReactTooltip
                                                                                      id={tooltipId}
                                                                                      place="top"
                                                                                      type="dark"
                                                                                      effect="solid"
                                                                                      backgroundColor="#007bff"
                                                                                  >
                                                                                      {option.value?.disabledTooltip ?? ""}
                                                                                  </ReactTooltip>
                                                                              </div>
                                                                          );
                                                                      }
                                                                      return <span>{option.label}</span>;
                                                                  }
                                                              }
                                                            : {})}
                                                    />
                                                </div>
                                            </div>
                                        </form>

                                        <div className="col-md-12 p-0 text-right btnOtr not-draggable">
                                            <button type="button" onClick={cancelForm} className="btn btn-primary btnRgion col-md-2 btncancel">
                                                Cancel
                                            </button>
                                            <button
                                                type="button"
                                                onClick={() => handleSubmit()}
                                                className="btn btn-primary btnRgion col-md-2"
                                                disabled={isLoading || (isAssetSurveyProject && !selectedValues?.length)}
                                            >
                                                {isLoading && (
                                                    <div className="button-loader d-flex justify-content-center align-items-center mt-2 mr-1">
                                                        <div className="spinner-border text-white" role="status">
                                                            <span className="sr-only">Loading...</span>
                                                        </div>
                                                    </div>
                                                )}
                                                Ok
                                            </button>
                                        </div>
                                    </>
                                ) : (
                                    <div className="region-mng not-draggable">
                                        <div className="tab-active">
                                            <h3>
                                                {sortedCurrentSelection?.length
                                                    ? sortedCurrentSelection?.map((userItem, i) => (
                                                          <span key={i} className="badge-otr notranslate">
                                                              {isAutoPopulate ? null : (
                                                                  <img
                                                                      src={userItem?.url ? userItem?.url : "/img/user-icon.png"}
                                                                      alt=""
                                                                      onError={e => {
                                                                          e.target.src = userItem?.url ? userItem?.url : "/img/user-icon.png";
                                                                      }}
                                                                  />
                                                              )}
                                                              <span className="nme">{userItem?.name}</span>
                                                          </span>
                                                      ))
                                                    : "No Data Available"}
                                            </h3>
                                        </div>
                                        <div className="col-md-12 p-0 text-right btnOtr">
                                            <button
                                                type="button"
                                                onClick={() => onCancel()}
                                                className={`btn btn-primary btnRgion col-md-2 ${isSurveyProjectView ? "btnclose" : ""}`}
                                            >
                                                Close
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </Draggable>
            </div>
            {renderConfirmationModal()}
        </React.Fragment>
    );
};
